import React from 'react';
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { MdSecurity, MdGavel } from "react-icons/md";
import { FaFileContract, FaHandshake, FaLock, FaMoneyBillWave } from "react-icons/fa";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { GoDotFill } from "react-icons/go";
import { CiMail } from "react-icons/ci";
import { FaWhatsapp, FaLaptopCode, FaCopyright } from "react-icons/fa";
import { BiTime } from "react-icons/bi";
import { RiShieldCheckFill } from "react-icons/ri";

const TermsConditions = () => {
  return (
    <>
      <div id="terms" className="bg-light">
        <section className="refund-policy-page">
          <div className="policy-header">
            <div className="container">
              <h1>
                <FaFileContract />&nbsp;Terms & Conditions
              </h1>
              <p className='text-start px-4'>
                Welcome to CodeFlex. These Terms and Conditions govern your use of our website, software, and professional IT services. By accessing our platform or engaging our services, you agree to these terms.
              </p>
            </div>
          </div>

          <div className="container pb-5">
            <div className="alert-box">
              <div className="alert-box-header">
                <h3><AiOutlineExclamationCircle />&nbsp;Important Notice</h3>
              </div>
              <p className='text-start px-4'>
                Please read these terms carefully before using our services. By engaging with CodeFlex, you acknowledge that you have read, understood, and agreed to be bound by these terms.
              </p>
            </div>

            {/* Use of Services Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Use of Services</h2>
              </div>

              <div className="sub-section sub-section-blue">
                <h3>a. Age Requirement</h3>
                <p>
                  You must be at least 18 years old to use our services.
                </p>
              </div>

              <div className="sub-section sub-section-green">
                <h3>b. Accurate Information</h3>
                <p>
                  You agree to provide accurate and complete information when registering or communicating with us.
                </p>
              </div>

              <div className="sub-section">
                <h3>c. Lawful Use</h3>
                <p>
                  You may not use our software or services for unlawful or unauthorized purposes.
                </p>
              </div>
            </div>

            {/* Software Licensing Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered purple">
                <h2>Software Licensing</h2>
              </div>

              <div className="service-card purple">
                <i className="bi bi-code-square"></i>
                <div className="service-card-content">
                  <h3><FaLaptopCode /><br /><br />License Grant</h3>
                  <p>Software provided by CodeFlex is licensed, not sold. You are granted a limited, non-transferable, non-exclusive right to use the software as per the terms of your license or agreement.</p>
                </div>
              </div>

              <div className="warning-alert">
                <i className="bi bi-exclamation-triangle-fill"></i>
                <p>Reverse engineering, copying, or redistributing the software without written permission is strictly prohibited.</p>
              </div>
            </div>

            {/* Service Engagement Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered green">
                <h2>Service Engagement</h2>
              </div>

              <ul className="exception-list">
                <li className="exception-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <p><GoDotFill />&nbsp;Project timelines, deliverables, and payments will be defined in a separate Service Agreement or Statement of Work (SOW).</p>
                </li>
                <li className="exception-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <p><GoDotFill />&nbsp;Delays caused by incomplete information or approvals from the client may affect project timelines.</p>
                </li>
                <li className="exception-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <p><GoDotFill />&nbsp;Any change requests will be handled through mutual written agreement.</p>
                </li>
              </ul>
            </div>

            {/* Payments Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Payments</h2>
              </div>

              <div className="service-card blue">
                <i className="bi bi-cash-coin"></i>
                <div className="service-card-content">
                  <h3><FaMoneyBillWave /><br /><br />Payment Terms</h3>
                  <p>All fees must be paid according to the terms stated in your invoice or service contract.</p>
                </div>
              </div>

              <div className="info-box warning">
                <i className="bi bi-exclamation-circle-fill"></i>
                <div className="info-box-content">
                  <p>
                    <IoMdCheckmarkCircleOutline />&nbsp;Late payments may incur additional charges or suspension of services.
                  </p>
                </div>
              </div>

              <div className="info-box neutral">
                <i className="bi bi-receipt"></i>
                <div className="info-box-content">
                  <p>
                    <IoMdCheckmarkCircleOutline />&nbsp;Taxes, transaction fees, and any third-party costs are the client's responsibility unless stated otherwise.
                  </p>
                </div>
              </div>
            </div>

            {/* Intellectual Property Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered purple">
                <h2>Intellectual Property</h2>
              </div>

              <div className="service-card purple">
                <i className="bi bi-shield-lock"></i>
                <div className="service-card-content">
                  <h3><FaCopyright /><br /><br />Ownership Rights</h3>
                  <p>Unless otherwise agreed, all intellectual property created during a project remains the property of CodeFlex until full payment is received.</p>
                </div>
              </div>

              <div className="service-card blue">
                <i className="bi bi-arrow-right-circle"></i>
                <div className="service-card-content">
                  <h3><FaHandshake /><br /><br />Rights Transfer</h3>
                  <p>Upon payment completion, ownership or usage rights will be transferred as per the agreed terms.</p>
                </div>
              </div>
            </div>

            {/* Limitation of Liability Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Limitation of Liability</h2>
              </div>

              <div className="info-box neutral">
                <i className="bi bi-shield-exclamation"></i>
                <div className="info-box-content">
                  <p>
                    <IoMdCheckmarkCircleOutline />&nbsp;CodeFlex shall not be liable for indirect, incidental, or consequential damages arising from the use or inability to use our products or services.
                  </p>
                </div>
              </div>

              <div className="info-box neutral">
                <i className="bi bi-cash"></i>
                <div className="info-box-content">
                  <p>
                    <IoMdCheckmarkCircleOutline />&nbsp;Our total liability under any contract shall not exceed the amount paid by you for the specific service.
                  </p>
                </div>
              </div>
            </div>

            {/* Confidentiality Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered green">
                <h2>Confidentiality</h2>
              </div>
              
              <div className="service-card purple">
                <i className="bi bi-lock-fill"></i>
                <div className="service-card-content">
                  <h3><FaLock /><br /><br />Mutual Confidentiality</h3>
                  <p>Both parties agree to maintain the confidentiality of proprietary or sensitive information exchanged during the course of the project.</p>
                </div>
              </div>
            </div>

            {/* Termination Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Termination</h2>
              </div>
              
              <div className="service-card blue">
                <i className="bi bi-x-octagon"></i>
                <div className="service-card-content">
                  <h3><BiTime /><br /><br />Termination Rights</h3>
                  <p>Either party may terminate a service agreement with written notice under conditions defined in the contract. Upon termination, the client must settle all outstanding invoices for work completed up to that date.</p>
                </div>
              </div>
            </div>

            {/* Governing Law Section */}
            <div className="processing-section text-start">
              <i className="bi bi-bank"></i>
              <div className="processing-content">
                <h2>Governing Law</h2>
                <p>These terms shall be governed by and interpreted in accordance with the laws of Sri Lanka.</p>
              </div>
            </div>

            {/* Acceptance Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered green">
                <h2>Acceptance of Terms</h2>
              </div>
              
              <div className="service-card purple">
                <i className="bi bi-check2-circle"></i>
                <div className="service-card-content">
                  <h3><RiShieldCheckFill /><br /><br />Your Agreement</h3>
                  <p>By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree, please discontinue use of our services immediately.</p>
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="contact-section text-start">
              <i className="bi bi-envelope-fill main-icon"></i>
              <h2><CiMail />&nbsp;Contact Us</h2>
              <div className='px-5'>
                <p>If you have questions about these Terms and Conditions, please contact:</p>
                <a href="mailto:support@codeflexofficial.com" className="contact-email-btn">
                  support@codeflexofficial.com
                </a>
                <br/><br/>
                <a
                  href="https://wa.me/94712129185"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-email-btn"
                  style={{ color: "#25D366" }}
                >
                  <FaWhatsapp />&nbsp;+94 71 21 29 185
                </a>
              </div>
            </div>

            {/* Last Updated */}
            <div className="text-center mt-4">
              <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
                Last Updated: October 13, 2025
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default TermsConditions;